import React from 'react';
import { Link } from "react-router-dom";
import { ROUTES } from "../../routes";
import "./health-care.css"
import ContactUS from "../../components/contact-us";
import { PortfolioRoute } from "../portfolio/route-porfolio";
// import { ToastComponent } from '../../components/common';
import * as contactAction from "../../action/contactAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactSEOMetaTags from 'react-seo-meta-tags';
import Helmet from 'react-helmet';
import Testimonials from '../../components/testimonials/testimonials';
import TestimonialsNew from '../../components/testimonials-new/testimonialsNew';
import Slider from 'react-slick';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


class Healthcare extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            headerClassAdd: "",
            showContactUS: false,
            showToast: false,
            show: false,
        }
        this.onScrollHeader = this.onScrollHeader.bind(this);
        // this.handleShow = this.handleShow.bind(this);
    }
    componentDidMount() {
        // factors
        if(window.factors) {
            window.factors.addUserProperties({'visited_healthcare_solutions_page': 'yes'});
        }
        window.addEventListener('scroll', this.onScrollHeader);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollHeader);
    }
    onScrollHeader() {
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop

        const height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight

        const scrolled = winScroll / height

        if (scrolled === 0) {
            this.setState({
                headerClassAdd: ""
            })
        } else {
            this.setState({
                headerClassAdd: "scrollHeader"
            })
        }
    }
    sendToast() {
        this.setState({ showContactUS: true })
    }

     handleClose(){
        this.setState({show: false})
     };
     handleShow(){
        this.setState({show: true})
     };
    render() {
        var blockSettings = {
            // className: "center",
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: true,
            centerMode: false,
            speed: 3000,
            speed: 2000,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1240,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    },
                },
                {
                    breakpoint: 1098,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
            ],
        };
        var webinarSettings = {
            // className: "center",
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: true,
            centerMode: false,
            speed: 3000,
            speed: 2000,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1240,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    },
                },
                {
                    breakpoint: 1098,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                    },
                },
            ],
        };
        return (
            <>
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1.0, shrink-to-fit=no, user-scalable=no, maximum-scale=1"
                    />
                    <title>Custom Healthcare Software Development Solution Company | IonixxTech </title>
                    <meta name="description" content="Ionixx helps customers with custom digital healthcare development solutions that are interoperable and help improve patient care and outcomes in the healthcare industry." />
                    <link rel="canonical" href="https://www.ionixxtech.com/healthcare-solutions" />
                </Helmet>
                <ReactSEOMetaTags
                    render={(el) => <Helmet>{el}</Helmet>}
                    website={{
                        name: "Ionixx Technologies",
                        title: "Custom Healthcare Software Development Solution Company | IonixxTech ",
                        description: "Ionixx helps customers with custom digital healthcare development solutions that are interoperable and help improve patient care and outcomes in the healthcare industry.",
                        type: "website",
                        image: 'assets/img/SEO_OG_IMAGE/HealthTech-Solutions.jpg',
                        url: "https://www.ionixxtech.com/healthcare-solutions"
                    }}
                    twitter={{
                        twitter: "https://www.ionixxtech.com/healthcare-solutions"
                    }}
                />
                <div className="Enterprise mob-view Healthcare">
                    <div className="section-1 common-hero-bg white-bg">
                        <div className="custom-container">
                            <div className="custom-section">
                                <div className="main-head-div">
                                    <h1 className="main-head-1 custom-htech-head">
                                        <span className="primary-span">Transforming The Healthcare Industry with Technology</span>
                                        <span className="secondary-span">We craft custom healthcare solutions for excellent patient outcomes.</span>
                                    </h1>
                                </div>
                                <div className="main-para-div short-div">
                                    <p>Leveraging our multifaceted expertise in the provider domain, we deliver digital healthcare solutions that <br></br> enhance efficiency, streamline workflows, and prioritize patient care.</p>
                                </div>
                                <div className="main-para-div talk-to-us">
                                    <Link to={ROUTES.CONTACTUS} className="btn btn-primary connect-btn">Talk to us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-4">
                        <div className="custom-container">
                            <div className="custom-section connect-with-custom-section">
                                <div className="main-head-div">
                                    <h4 className="main-head-1 main-head-2 text-center">
                                        
                                        <span className="primary-span new-heading">Custom Digital Healthcare Solutions for<br></br> Future-Proof Operations</span>
                                    </h4>
                                </div>
                                <p className='health-para text-center'>
                                    From integrating new functionalities to full-scale healthcare software development, our custom solutions incorporate best-of-breed technologies to empower you to meet current and future patient care goals.
As an established healthcare software development company, we have a rich portfolio of digital healthcare solutions driving patient engagement and automating fastidious tasks in inpatient and outpatient care. Our customized healthcare services will fit seamlessly with your business requirements to bring your most ambitious ideas to life.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="company-info">
                        <div className="section-2 beige-bg exp-contaniner">
                            <div className="custom-container">
                                <div className="custom-section">
                                    <div className="row work-with-row">
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 work-with-col">
                                            <div className="left-info-hold">
                                                <div className="main-head-div custom-main-head-div">
                                                    <h2 className="main-head-1 main-head-2">
                                                        <span className="primary-span">Our Innovative Healthcare Expertise</span>
                                                    </h2>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='content-section'>
                                            <div className='col-lg-4 col-md-4 col-sm-6 solution-list'>
                                                <i><img src='/assets/img/health-img/mental-health.png' /></i>
                                                <strong>AI-Powered Healthcare</strong>
                                                <span>Deliver enhanced health outcomes and patient experiences with our customized digital health solutions powered by artificial intelligence (AI) that integrate into your healthcare services to improve diagnosis accuracy, enhance patient engagement, fast-track drug discovery, and reduce administrative and expenditure burdens.</span>
                                            </div>
                                            <div className='col-lg-4 col-md-4 col-sm-6 solution-list'>
                                                <i><img src='/assets/img/health-img/ai.png' /></i>
                                                <strong>Health 4.0</strong>
                                                <span>Provide personalized patient care at scale with Health Tech 4.0. Bank on our expertise in building holistic healthcare ecosystems that combine data, emerging medical technology, and digital channels for delivering improved patient care and personalized treatments at reduced costs.</span>
                                            </div>
                                            <div className='col-lg-4 col-md-4 col-sm-6 solution-list'>
                                                <i><img src='/assets/img/health-img/heart-condition.png' /></i>
                                                <strong>HealthTech Air</strong>
                                                <span>Modernize digital healthcare by reinforcing it with Ionixx’s flexible and scalable cloud and digital infrastructure. Equip your healthcare services with the resilient and secure infrastructure to effectively store, manage, and analyze patient data, deliver care remotely, and enhance collaboration for driving efficient healthcare delivery and better patient outcomes.</span>
                                            </div>
                                            <div className='col-lg-4 col-md-4 col-sm-6 solution-list'>
                                                <i><img src='/assets/img/health-img/mental-health.png' /></i>
                                                <strong>Telemedicine</strong>
                                                <span>Facilitate contactless treatments and remote patient-doctor interactions with user-centric telemedicine applications. Roll out high-quality care and consultation services through chat and video interfaces to make healthcare services more accessible.</span>
                                            </div>
                                            <div className='col-lg-4 col-md-4 col-sm-6 solution-list'>
                                                <i><img src='/assets/img/health-img/ai.png' /></i>
                                                <strong>ePrescribing</strong>
                                                <span>Streamline prescriptions for patient convenience, reduced errors, enhanced medication adherence, and tracking with our ePrescription solutions for healthcare industry. Accelerate patient care with an eRx process tailored to improve patient experience and aligned with regulations standardizing e-prescribing.</span>
                                            </div>
                                            <div className='col-lg-4 col-md-4 col-sm-6 solution-list'>
                                                <i><img src='/assets/img/health-img/ai.png' /></i>
                                                <strong>Data Analytics</strong>
                                                <span>Enable real-time population health insights with fast, cost-effective analytics deployment and enhanced end-to-end experience by integrating Neuron's platform with cloud and on-prem systems. Effortlessly scale to handle vast populations while ensuring regulatory compliance, easy configuration, and adaptability across diverse healthcare solutions.</span>
                                                {/* <em onClick={() => this.handleShow()}>Read more...</em> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    {/* <div  className="section-2 marketplace blue-bg">
                    <div  className="custom-container">
                        <div  className="custom-section">
                            <div  className="main-head-div">
                                <h2  className="main-head-1 custom-htech-head">
                                    <span  className="primary-span">Our Solutions</span>
                                </h2>
                            </div>
                            
                        </div>
                    </div>
                         <div className="tab-card">
                                <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 resp-health-cards">
                                        <div className="cardClick port-card">
                                            <div className="whole-port">
                                                    {/* <div className="card-img">
                                                        <img src="/assets/img/steth.png" title="Steth IO" alt="Steth IO"/>
                                                    </div> 
                                                    <div className="card-img">
                                                        <div className="content">
                                                            <div className="content-overlay"></div>
                                                             <img className="content-image" src="/assets/img/steth.png" title="Steth IO" alt="Steth IO"/>
                                                             <div className="content-details fadeIn-bottom">
                                                                <p className="content-text">To know more about this project</p>
                                                                <button onClick={this.sendToast.bind(this)} className="port-btn">Talk to an expert</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-head">
                                                        <h4>Steth IO</h4>
                                                    </div>
                                                    <div className="card-cap">
                                                        <p>Patient centric medical consultation platform.</p>
                                                    </div>
                                                    <div className="more-text">
                                                    {/* <a>Learn More</a> 
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 resp-health-cards">
                                        <div className="port-card cardClick">
                                            <div className="whole-port">
                                                    {/* <div className="card-img">
                                                      <img src="/assets/img/chip.png" title="Doc Talk" alt="Doc Talk"/>
                                                    </div> 
                                                    <div className="card-img">
                                                        <div className="content">
                                                            <div className="content-overlay"></div>
                                                             <img className="content-image" src="/assets/img/chip.png" title="Doc Talk" alt="Doc Talk"/>
                                                             <div className="content-details fadeIn-bottom">
                                                                <p className="content-text">To know more about this project</p>
                                                                <button onClick={this.sendToast.bind(this)} className="port-btn">Talk to an expert</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-head">
                                                        <h4>Doc Talk</h4>
                                                    </div>
                                                    <div className="card-cap">
                                                        <p>HIPAA-compliant Healthcare Communications App.</p>
                                                    </div>
                                                    <div className="more-text">
                                                    {/* <a>Learn More</a> 
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 resp-health-cards">
                                        <div className="port-card cardClick">
                                            <div className="whole-port">
                                                    <div className="card-img">
                                                        <div className="content">
                                                            <div className="content-overlay"></div>
                                                             <img className="content-image" src="/assets/img/hps.png" title="HPS" alt="HPS"/>
                                                             <div className="content-details fadeIn-bottom">
                                                                <p className="content-text">To know more about this project</p>
                                                                <button onClick={this.sendToast.bind(this)} className="port-btn">Talk to an expert</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-head">
                                                        <h4>HPS</h4>
                                                    </div>
                                                    <div  className="card-cap">
                                                        <p>Health and benefits administration software.</p>
                                                    </div>
                                                    <div className="more-text">
                                                    {/* <a>Learn More</a> 
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    <div  className="custom-container">
                        <div  className="port-more">
                             <div className="more-text">
                               <Link to={ROUTES.PORTFOLIO}>
                                 <a>View our complete portfolio</a>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>  */}

                    <div className="section-4">
                        <div className="custom-container">
                            <div className="custom-section connect-with-custom-section">
                                <div className="main-head-div">
                                    <h4 className="main-head-1">
                                        {/* <span   className="secondary-span">Get Started!</span> */}
                                        <span className="primary-span new-heading">Our Portfolio</span>
                                    </h4>
                                </div>
                                <div className='business-showcase'>
                                    <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 business-list'>
                                        <div className='business-img'>
                                            <img src='/assets/img/health-img/doc-talk.png' />
                                            <div className='talk-section'>
                                                <div className='talk-detail'>
                                                    <span>To know more about this project</span>
                                                    <Link to={ROUTES.CONTACTUS}>Talk to an expert</Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='business-detail'>
                                            <b>Doc Talk</b>
                                            <p>HIPAA-compliant Healthcare Communications App</p>
                                            {/* <div className='business-link'>
                                        <a href='#'>Learn more</a>
                                        </div> */}
                                        </div>
                                    </div>
                                    <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 business-list'>
                                        <div className='business-img'>
                                            <img src='/assets/img/health-img/stethio.png' />
                                            <div className='talk-section'>
                                                <div className='talk-detail'>
                                                    <span>To know more about this project</span>
                                                    <Link to={ROUTES.CONTACTUS}>Talk to an expert</Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='business-detail'>
                                            <b>Steth IO</b>
                                            <p>Patient centric medical consultation platform</p>
                                            {/* <div className='business-link'>
                                        <a href='#'>Learn more</a>
                                        </div> */}
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='section-5'>
                        
                        <div className="custom-container">
                            <div className='why-choose'>

                                <div className="main-head-div headings">
                                    <h4 className="main-head-1 main-head-2 text-center">
                                        {/* <span   className="secondary-span">Get Started!</span> */}
                                        <span className="primary-span new-heading text-center">Why Choose Ionixx for Custom Healthcare Software Development?</span>
                                    </h4>
                                </div>
                                <div className="compilance-section">
                        
                                <div className='compilance-list col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                    <i><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                                        <g clip-path="url(#clip0_5984_26301)">
                                            <path d="M76.6631 18.337C76.6629 18.337 76.6625 18.337 76.6622 18.337C73.9024 18.3341 71.6658 16.0975 71.6629 13.3376C71.6629 12.4173 70.9167 11.6711 69.9964 11.6711C69.0761 11.6711 68.3299 12.4173 68.3299 13.3376C68.327 16.0975 66.0904 18.3341 63.3305 18.337C62.4102 18.337 61.6641 19.0832 61.6641 20.0035C61.6641 20.9238 62.4102 21.6699 63.3305 21.6699C66.0904 21.6729 68.327 23.9095 68.3299 26.6693C68.3299 27.5896 69.0761 28.3358 69.9964 28.3358C70.9167 28.3358 71.6629 27.5896 71.6629 26.6693C71.6658 23.9095 73.9024 21.6729 76.6622 21.6699C77.5823 21.6701 78.3285 20.9244 78.3287 20.0043C78.3287 20.0041 78.3287 20.0037 78.3287 20.0035C78.3289 19.0834 77.5832 18.3372 76.6631 18.337ZM69.9964 21.6749C69.5208 21.0419 68.9582 20.4792 68.3251 20.0037C68.9582 19.5281 69.5208 18.9655 69.9964 18.3324C70.472 18.9655 71.0346 19.5281 71.6676 20.0037C71.0346 20.479 70.472 21.0419 69.9964 21.6749Z" fill="white" />
                                            <path d="M36.6701 18.337C33.9102 18.3341 31.6736 16.0975 31.6707 13.3376C31.6707 12.4173 30.9245 11.6711 30.0042 11.6711C29.0839 11.6711 28.3377 12.4173 28.3377 13.3376C28.3348 16.0975 26.0982 18.3341 23.3383 18.337C22.418 18.337 21.6719 19.0832 21.6719 20.0035C21.6719 20.9238 22.418 21.6699 23.3383 21.6699C26.0982 21.6729 28.3348 23.9095 28.3377 26.6693C28.3377 27.5896 29.0839 28.3358 30.0042 28.3358C30.9245 28.3358 31.6707 27.5896 31.6707 26.6693C31.6736 23.9095 33.9102 21.6729 36.6701 21.6699C37.5904 21.6699 38.3365 20.9238 38.3365 20.0035C38.3365 19.0832 37.5904 18.337 36.6701 18.337ZM30.0042 21.6749C29.5286 21.0419 28.966 20.4792 28.3329 20.0037C28.966 19.5281 29.5286 18.9655 30.0042 18.3324C30.4798 18.9655 31.0424 19.5281 31.6755 20.0037C31.0424 20.479 30.4798 21.0419 30.0042 21.6749Z" fill="white" />
                                            <path d="M56.6662 6.67221C53.9063 6.66929 51.6697 4.43269 51.6668 1.67281C51.667 0.752716 50.9212 0.00655601 50.0011 0.0063477C50.0009 0.0063477 50.0005 0.0063477 50.0003 0.0063477C49.0802 0.00613939 48.334 0.751882 48.3338 1.67198C48.3338 1.67219 48.3338 1.6726 48.3338 1.67281C48.3309 4.43269 46.0943 6.66929 43.3344 6.67221C42.4141 6.67221 41.668 7.41837 41.668 8.33867C41.668 9.25898 42.4141 10.0051 43.3344 10.0051C46.0943 10.0081 48.3309 12.2447 48.3338 15.0045C48.3338 15.9248 49.08 16.671 50.0003 16.671C50.9206 16.671 51.6668 15.9248 51.6668 15.0045C51.6697 12.2447 53.9063 10.0081 56.6662 10.0051C57.5865 10.0051 58.3326 9.25898 58.3326 8.33867C58.3326 7.41837 57.5865 6.67221 56.6662 6.67221ZM50.0003 10.0101C49.5247 9.37709 48.9621 8.81445 48.329 8.33888C48.9621 7.86331 49.5247 7.30067 50.0003 6.66763C50.4759 7.30067 51.0385 7.86331 51.6716 8.33888C51.0385 8.81424 50.4759 9.37709 50.0003 10.0101Z" fill="white" />
                                            <path d="M49.9994 25.0027C35.2737 25.0027 23.3359 36.9404 23.3359 51.6661C23.3359 66.3918 35.2737 78.3296 49.9994 78.3296C64.7182 78.3127 76.646 66.385 76.6628 51.6661C76.6628 36.9404 64.7251 25.0027 49.9994 25.0027ZM49.9994 74.9966C37.1143 74.9966 26.6689 64.5512 26.6689 51.6661C26.6689 38.781 37.1143 28.3356 49.9994 28.3356C62.8845 28.3356 73.3299 38.781 73.3299 51.6661C73.3153 64.5452 62.8784 74.9823 49.9994 74.9966Z" fill="white" />
                                            <path d="M33.3359 49.9999H36.6689C36.6772 42.6405 42.6413 36.6765 50.0006 36.6681V33.3352C40.8013 33.3458 33.3464 40.8006 33.3359 49.9999Z" fill="#FFCC4A" />
                                            <path d="M99.9943 77.4919L99.9666 48.0496C99.9618 43.4612 97.1088 40.0012 93.3284 40.0012H93.0095C89.3301 40.1979 86.3797 43.1156 86.1418 46.7925L82.0439 67.8803C80.6447 67.6718 79.2189 68.0107 78.0634 68.8267L65.4868 77.6717C64.1367 78.6238 63.3331 80.1726 63.332 81.8247V98.3275C63.3318 99.2476 64.0776 99.9938 64.9977 99.994C64.9979 99.994 64.9983 99.994 64.9985 99.994H81.6632C82.5832 99.9942 83.3294 99.2484 83.3296 98.3283C83.3296 98.3281 83.3296 98.3277 83.3296 98.3275V96.2192L94.3016 89.2336C98.0051 86.4862 100.131 82.1011 99.9943 77.4919ZM92.4773 86.4441L80.7681 93.8984C80.2877 94.2047 79.9969 94.7348 79.9967 95.3045V96.661H66.665V81.8247C66.6652 81.2566 66.9414 80.7242 67.4055 80.3965L79.9804 71.5524C80.9626 70.8619 82.3185 71.0985 83.009 72.0807C83.2663 72.4467 83.4044 72.8831 83.4044 73.3303C83.4125 73.8603 83.2228 74.3739 82.8722 74.7714L72.2566 83.7214L74.4047 86.2698L85.1244 77.2246C87.271 75.0778 87.2754 71.5986 85.1342 69.4464L89.4305 47.3153C89.4791 45.2875 90.9981 43.5977 93.0093 43.3339H93.3282C95.2094 43.3339 96.6303 45.3624 96.6334 48.0525L96.6611 77.4931C96.803 80.9796 95.2428 84.3171 92.4773 86.4441Z" fill="white" />
                                            <path d="M34.5118 77.6708L21.9368 68.8267C20.7809 68.0112 19.3555 67.6722 17.9563 67.8803L13.8764 46.9056C13.672 43.1875 10.7082 40.2158 6.99074 40.0012H6.67182C2.89144 40.0012 0.0384503 43.461 0.0336592 48.0496L0.00595418 77.4936C-0.128196 82.1161 2.01134 86.511 5.73276 89.2565L16.6706 96.2194V98.3277C16.6704 99.2478 17.4161 99.994 18.3362 99.9942C18.3364 99.9942 18.3369 99.9942 18.3371 99.9942H35.0017C35.9218 99.9944 36.668 99.2486 36.6682 98.3285C36.6682 98.3283 36.6682 98.3279 36.6682 98.3277V81.8249C36.6669 80.172 35.8629 78.623 34.5118 77.6708ZM33.3353 96.661H20.0035V95.3045C20.0033 94.7348 19.7125 94.2047 19.2322 93.8984L7.55713 86.4668C4.77329 84.3419 3.19932 80.9942 3.33888 77.495L3.36659 48.0527C3.36992 45.3627 4.79058 43.3342 6.67182 43.3342H6.99074C9.0384 43.6195 10.5684 45.3612 10.5874 47.4287L14.8658 69.4466C12.7246 71.5989 12.729 75.078 14.8756 77.2248C14.9369 77.2857 15.0027 77.3417 15.0725 77.3925L27.3545 86.3425L29.3172 83.6491L17.1539 74.7862C16.3502 73.894 16.4219 72.5194 17.3139 71.7157C18.0673 71.0368 19.1901 70.9691 20.0198 71.5526L32.5931 80.3959C33.058 80.7232 33.3348 81.2562 33.3353 81.8247V96.661Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5984_26301">
                                                <rect width="100" height="100" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg></i>
                                    <strong>Custom Healthcare Solutions</strong>
                                    <span>We design, develop, test, and deliver digital healthcare solutions that are tailored to integrate into your ecosystem to address your unique pain points and requirements.</span>
                                </div>
                                <div className='compilance-list col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                    <i><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                                        <g clip-path="url(#clip0_5984_26253)">
                                            <path d="M79.0323 0C90.5935 0 100 9.40645 100 20.9677H96.7742C96.7742 11.1855 88.8145 3.22581 79.0323 3.22581C69.25 3.22581 61.2903 11.1855 61.2903 20.9677V33.8919H58.0645V20.9677C58.0645 9.40645 67.471 0 79.0323 0Z" fill="white" />
                                            <path d="M61.2903 37.0972C61.2903 46.8794 69.25 54.8391 79.0323 54.8391C88.8145 54.8391 96.7742 46.8794 96.7742 37.0972V24.194H100V37.0972C100 48.6585 90.5935 58.0649 79.0323 58.0649C67.471 58.0649 58.0645 48.6585 58.0645 37.0972H61.2903Z" fill="white" />
                                            <path d="M67.7404 25.7969V37.0953C67.7404 43.3211 72.8049 48.3856 79.0307 48.3856C85.2566 48.3856 90.3211 43.3211 90.3211 37.0953V35.4824H93.5469V37.0953C93.5469 45.0985 87.034 51.6114 79.0307 51.6114C71.0275 51.6114 64.5146 45.0985 64.5146 37.0953V25.7969H67.7404Z" fill="white" />
                                            <path d="M79.0307 6.45142C87.034 6.45142 93.5469 12.9643 93.5469 20.9675V32.2579H90.3211V20.9675C90.3211 14.7417 85.2566 9.67722 79.0307 9.67722C72.8049 9.67722 67.7404 14.7417 67.7404 20.9675V22.8466H64.5146V20.9675C64.5146 12.9643 71.0275 6.45142 79.0307 6.45142Z" fill="white" />
                                            <path d="M6.452 41.9356C7.78909 41.9356 9.03263 42.3453 10.0633 43.0453C10.9455 40.5291 13.3165 38.7098 16.1294 38.7098C17.4665 38.7098 18.7101 39.1195 19.7407 39.8195C20.623 37.3033 22.9939 35.484 25.8068 35.484C26.9875 35.484 28.0794 35.8259 29.0326 36.3807V19.3549C29.0326 15.7969 31.9262 12.9033 35.4842 12.9033C39.0423 12.9033 41.9359 15.7969 41.9359 19.3549V43.5485H43.5488C47.9955 43.5485 51.6133 47.1662 51.6133 51.613V70.6275C51.6133 74.4114 49.7326 77.9227 46.5859 80.0211L41.9359 83.1211V100H8.0649V83.0324L4.23748 79.9711C1.54554 77.8178 0.00038147 74.6033 0.00038147 71.1549V48.3872C0.00038147 44.8291 2.89393 41.9356 6.452 41.9356ZM3.22619 71.1549C3.22619 73.6178 4.32941 75.913 6.25199 77.4517L11.2907 81.484V96.7743H38.7101V81.3953L44.7955 77.3372C47.0439 75.8388 48.3875 73.3307 48.3875 70.6275V51.613C48.3875 48.9453 46.2165 46.7743 43.5488 46.7743H41.9359V61.2904H38.7101V19.3549C38.7101 17.5759 37.2633 16.1291 35.4842 16.1291C33.7052 16.1291 32.2584 17.5759 32.2584 19.3549V41.9356V56.4517H29.0326V41.9356C29.0326 40.1565 27.5859 38.7098 25.8068 38.7098C24.0278 38.7098 22.581 40.1565 22.581 41.9356V45.1614V56.4517H19.3552V45.1614C19.3552 43.3824 17.9084 41.9356 16.1294 41.9356C14.3504 41.9356 12.9036 43.3824 12.9036 45.1614V48.3872V56.4517H9.6778V48.3872C9.6778 46.6082 8.23103 45.1614 6.452 45.1614C4.67296 45.1614 3.22619 46.6082 3.22619 48.3872V71.1549Z" fill="white" />
                                            <path d="M77.4187 20.968H80.6445V37.0971H77.4187V20.968Z" fill="#FFCC4A" />
                                            <path d="M74.1944 32.0321V37.0966C74.1944 39.7643 76.3654 41.9353 79.0331 41.9353C81.7009 41.9353 83.8719 39.7643 83.8719 37.0966V20.9676C83.8719 20.1176 83.6477 19.2805 83.2251 18.5482L86.0186 16.9353C86.7251 18.1547 87.0977 19.5498 87.0977 20.9676V37.0966C87.0977 41.5434 83.4799 45.1611 79.0331 45.1611C74.5864 45.1611 70.9686 41.5434 70.9686 37.0966V32.0321H74.1944Z" fill="#FFCC4A" />
                                            <path d="M79.0327 12.9033C80.3311 12.9033 81.6198 13.2194 82.7617 13.8162L81.2666 16.6743C80.5762 16.313 79.823 16.1291 79.0327 16.1291C76.3649 16.1291 74.194 18.3001 74.194 20.9678V28.7517H70.9682V20.9678C70.9682 16.5211 74.5859 12.9033 79.0327 12.9033Z" fill="#FFCC4A" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5984_26253">
                                                <rect width="100" height="100" fill="white" transform="matrix(-1 0 0 1 100 0)" />
                                            </clipPath>
                                        </defs>
                                    </svg></i>
                                    <strong>Seamlessly Interoperable</strong>
                                    <span>Comprehensive use and engagement with standards such as SNOMED, HL7, FHIR, LOINC, NCPDP, CPT, and more.</span>
                                </div>
                                <div className='compilance-list col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                    <i><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                                        <g clip-path="url(#clip0_5984_26282)">
                                            <path d="M34.8452 74.2433C36.9432 72.5682 38.56 70.3213 39.476 67.7421H40.3226C43.8807 67.7421 46.7742 64.8486 46.7742 61.2905C46.7742 58.9128 45.4676 56.855 43.5484 55.7359V48.3872C43.5484 41.2725 37.7599 35.484 30.6452 35.484H20.9677C13.853 35.484 8.06452 41.2725 8.06452 48.3872V55.7359C6.14526 56.855 4.83871 58.9128 4.83871 61.2905C4.83871 64.8486 7.73217 67.7421 11.2903 67.7421H12.1369C13.0529 70.3213 14.6697 72.5666 16.7677 74.2433C7.43841 74.7536 0 82.4811 0 91.9356V98.3872C0 99.2772 0.720609 100 1.6129 100H50C50.8923 100 51.6129 99.2772 51.6129 98.3872V91.9356C51.6129 82.4811 44.1745 74.7536 34.8452 74.2433ZM28.9015 77.4195L25.8064 81.2887L22.7114 77.4195H28.9015ZM40.3226 64.5163H40.2273C40.2871 63.9855 40.3226 63.4483 40.3226 62.9034V58.0647C42.1017 58.0647 43.5484 59.5114 43.5484 61.2905C43.5484 63.0695 42.1017 64.5163 40.3226 64.5163ZM11.2903 48.3872C11.2903 43.05 15.6305 38.7098 20.9677 38.7098H30.6452C35.9824 38.7098 40.3226 43.05 40.3226 48.3872V54.8388H33.871C32.0919 54.8388 30.6452 53.3921 30.6452 51.613V45.1614H27.4194V46.7743C27.4194 51.2208 23.8013 54.8388 19.3548 54.8388H11.2903V48.3872ZM11.2903 64.5163C9.51125 64.5163 8.06452 63.0695 8.06452 61.2905C8.06452 59.5114 9.51125 58.0647 11.2903 58.0647V62.9034C11.2903 63.4483 11.3258 63.9855 11.3856 64.5163H11.2903ZM14.5161 62.9034V58.0647H19.3548C22.7807 58.0647 25.8498 56.5242 27.9226 54.1064C28.8999 56.4289 31.1964 58.0647 33.871 58.0647H37.0968V62.9034C37.0968 69.1289 32.0305 74.1937 25.8064 74.1937C19.5824 74.1937 14.5161 69.1289 14.5161 62.9034ZM48.3871 96.7743H3.22581V91.9356C3.22581 83.9325 9.73727 77.4195 17.7419 77.4195H18.5791L24.5472 84.8792C24.8535 85.2611 25.3158 85.484 25.8064 85.484C26.2971 85.484 26.7594 85.2611 27.0657 84.8792L33.0338 77.4195H33.871C41.8756 77.4195 48.3871 83.9325 48.3871 91.9356V96.7743Z" fill="white" />
                                            <path d="M99.9981 29.0323C99.9981 23.5454 91.6241 19.9502 81.5112 18.487C80.0479 8.37402 76.4527 0 70.9659 0C65.479 0 61.8822 8.3756 60.419 18.4901C59.2495 18.6579 58.1178 18.8563 57.0144 19.0792C55.8646 17.308 53.8768 16.129 51.611 16.129C48.0529 16.129 45.1594 19.0225 45.1594 22.5806C45.1594 22.9224 45.209 23.2516 45.261 23.5793C42.5565 25.5851 41.9336 27.6194 41.9336 29.0323C41.9336 34.5191 50.3076 38.1143 60.4206 39.5776C61.8838 49.6905 65.479 58.0645 70.9659 58.0645C76.4527 58.0645 80.0495 49.6889 81.5127 39.5744C82.6822 39.4067 83.8139 39.2082 84.9173 38.9853C86.0671 40.7565 88.0549 41.9355 90.3207 41.9355C93.8788 41.9355 96.7723 39.042 96.7723 35.4839C96.7723 35.1421 96.7227 34.8129 96.6707 34.4853C99.3752 32.4794 99.9981 30.4451 99.9981 29.0323ZM70.9659 3.22581C73.4774 3.22581 76.7252 8.69062 78.216 18.0987C75.8258 17.8679 73.3852 17.7419 70.9659 17.7419C68.4969 17.7419 66.0689 17.8695 63.7172 18.0916C65.2081 8.68904 68.4544 3.22581 70.9659 3.22581ZM79.0304 29.0323C79.0304 31.7824 78.8839 34.3356 78.635 36.7014C76.1676 36.9613 73.5884 37.0968 70.9659 37.0968C68.2157 37.0968 65.6625 36.9503 63.2967 36.7014C63.0478 34.3356 62.9013 31.7824 62.9013 29.0323C62.9013 26.2821 63.0478 23.7289 63.2967 21.3631C65.7641 21.1032 68.3433 20.9677 70.9659 20.9677C73.716 20.9677 76.2692 21.1142 78.635 21.3631C78.8839 23.7289 79.0304 26.2821 79.0304 29.0323ZM51.611 19.3548C53.3901 19.3548 54.8368 20.8016 54.8368 22.5806C54.8368 24.3597 53.3901 25.8065 51.611 25.8065C49.8319 25.8065 48.3852 24.3597 48.3852 22.5806C48.3852 20.8016 49.8319 19.3548 51.611 19.3548ZM45.1594 29.0323C45.1594 28.2675 45.6721 27.4351 46.6156 26.6129C47.8001 28.0762 49.587 29.0323 51.611 29.0323C55.1692 29.0323 58.0626 26.1388 58.0626 22.5806C58.0626 22.4405 58.0303 22.3082 58.0209 22.1695C58.6856 22.0388 59.34 21.9018 60.0307 21.7939C59.8015 24.1794 59.6755 26.6176 59.6755 29.0323C59.6755 31.4516 59.8015 33.8922 60.0323 36.2824C50.6242 34.7916 45.1594 31.5438 45.1594 29.0323ZM70.9659 54.8387C68.4544 54.8387 65.2065 49.3739 63.7157 39.9658C66.1059 40.1966 68.5465 40.3226 70.9659 40.3226C73.4348 40.3226 75.8628 40.195 78.216 39.9729C76.7236 49.3755 73.4774 54.8387 70.9659 54.8387ZM90.3207 38.7097C88.5416 38.7097 87.0949 37.2629 87.0949 35.4839C87.0949 33.7048 88.5416 32.2581 90.3207 32.2581C92.0998 32.2581 93.5465 33.7048 93.5465 35.4839C93.5465 37.2629 92.0998 38.7097 90.3207 38.7097ZM95.3161 31.4516C94.1316 29.9883 92.3447 29.0323 90.3207 29.0323C86.7625 29.0323 83.8691 31.9257 83.8691 35.4839C83.8691 35.6241 83.9014 35.7564 83.9108 35.895C83.2461 36.0257 82.5932 36.1627 81.901 36.2706C82.1302 33.8851 82.2562 31.4469 82.2562 29.0323C82.2562 26.6129 82.1302 24.1723 81.8994 21.7821C91.3075 23.2729 96.7723 26.5208 96.7723 29.0323C96.7723 29.797 96.2596 30.6294 95.3161 31.4516Z" fill="#FFCC4A" />
                                            <path d="M62.5303 66.7099C61.916 65.9743 60.6654 65.9743 60.0511 66.7099L51.9866 76.3873C51.5865 76.8685 51.4999 77.5379 51.7661 78.1034C52.0299 78.6696 52.5993 79.0327 53.2254 79.0327H54.8383V87.0972H58.0641V77.4198C58.0641 76.5992 57.4514 75.9211 56.6576 75.8195L61.2899 70.2617L65.9223 75.8195C65.1285 75.9211 64.5157 76.5992 64.5157 77.4198V87.0972H67.7415V79.0327H69.3545C69.9806 79.0327 70.55 78.6696 70.8138 78.1034C71.08 77.5356 70.9933 76.8669 70.5933 76.3873L62.5303 66.7099Z" fill="white" />
                                            <path d="M54.8398 90.3228H58.0656V93.5486H54.8398V90.3228Z" fill="white" />
                                            <path d="M54.8398 96.7739H58.0656V99.9997H54.8398V96.7739Z" fill="white" />
                                            <path d="M64.5156 90.3228H67.7414V93.5486H64.5156V90.3228Z" fill="white" />
                                            <path d="M64.5156 96.7739H67.7414V99.9997H64.5156V96.7739Z" fill="white" />
                                            <path d="M85.1124 57.0325C84.4981 56.2969 83.2474 56.2969 82.6331 57.0325L74.5686 66.7099C74.1686 67.1911 74.0819 67.8605 74.3481 68.426C74.6119 68.9923 75.1813 69.3553 75.8075 69.3553H77.4204V77.4198H80.6462V67.7424C80.6462 66.9218 80.0334 66.2437 79.2396 66.1421L83.872 60.5844L88.5043 66.1421C87.7105 66.2437 87.0978 66.9218 87.0978 67.7424V77.4198H90.3236V69.3553H91.9365C92.5626 69.3553 93.132 68.9923 93.3958 68.426C93.662 67.8582 93.5754 67.1895 93.1753 66.7099L85.1124 57.0325Z" fill="white" />
                                            <path d="M77.418 80.6455H80.6438V83.8713H77.418V80.6455Z" fill="white" />
                                            <path d="M77.418 87.0967H80.6438V90.3225H77.418V87.0967Z" fill="white" />
                                            <path d="M87.0977 80.6454H90.3235V83.8712H87.0977V80.6454Z" fill="white" />
                                            <path d="M87.0977 87.0966H90.3235V90.3224H87.0977V87.0966Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5984_26282">
                                                <rect width="100" height="100" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg></i>
                                    <strong>Custom Solutions</strong>
                                    <span>We design, develop, test and deliver
                                        solutions that fit in your ecosystem
                                        to address the pain points you have.</span>
                                </div>
                            </div>      
                            </div>
                            
                            
                        </div>
                    </div>

                    <div className='section-6'>
                        <div className='custom-container'>
                            <div className='why-choose left-section'>
                                <div className="main-head-div headings">
                                        <h4 className="main-head-1 main-head-2 text-center">
                                            {/* <span   className="secondary-span">Get Started!</span> */}
                                            <span className="primary-span new-heading text-center">Meeting The Industry-specific Standards in<br></br> Healthcare Technology</span>
                                        </h4>
                                    </div>
                                <div className='robust-container'>
                                    <div className='left-robust'>
                                        <img src='/assets/img/health-img/health-robust.png' />
                                    </div>
                                    <div className='right-robust'>
                                        <h3>Robust, Scalable and Secure</h3>
                                        <strong>Preparing your infrastructure for the future.</strong>
                                        <p>All solutions we offer or curate are fortified with robust security measures and designed to withstand disruptions in the healthcare industry. Our comprehensive approach includes state-of-the-art authentication, encryption, and access controls. As a leading healthcare software development company,
we continuously monitor and update systems, deploying advanced medical technology and conducting regular audits. With redundant infrastructure and disaster recovery measures, we build resilience to navigate disruptions.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='section-7'>
                        <div className='custom-container'>
                            <div className="main-head-div">
                                <h4 className="main-head-1">
                                    <span className="primary-span new-heading">Healthcare blogs</span>
                                </h4>
                            </div>

                            <div className='health-blogs'>
                                <Slider {...blockSettings}>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>Health 4.0</strong>
                                            <em>The Evolution, Impact, and Opportunities of ePrescribing</em>
                                            <p>Artificial intelligence (AI) has become a driving force behind innovation across numerous industries, with healthcare standing out as a prime example.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/the-evolution-impact-and-opportunities-of-eprescribing/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>Telemedicine</strong>
                                            <em>The Role of Machine Learning in Medical Decision</em>
                                            <p>The term AI has become ubiquitous in the first half of 2023, with every industry hopping on the bandwagon of ChatGPT and GPT-4.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/ai-in-healthtech/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>The Evolving Role of AI in Diagnosing and Treating Patients</em>
                                            <p>In the dynamic landscape of healthcare, technology’s role in patient care continues to grow, and one of the key drivers of this change is ePrescribing (eRx)</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/the-evolving-role-of-ai-in-diagnosing-and-treating-patients/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>Health 4.0</strong>
                                            <em>Call for Submissions: Healthcare Design Contest 2021</em>
                                            <p>The onslaught of the Covid-19 pandemic has wreaked havoc to a fragile healthcare system and exposed the gaping holes in the global healthcare framework.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/call-for-submissions-healthcare-design-contest-2021/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>How Blockchain Technology Is Redefining the Industry</em>
                                            <p>With companies and institutions in the healthcare industry growing their technology spending by 8% per year, spending is on more than just equipment.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/the-latest-in-blockchain-for-healthcare-how-blockchain-technology-is-redefining-the-industry/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>4 Disruptive Trends Shaping the Healthcare Sector</em>
                                            <p>The tech industry is continuing to revolutionize the way people experience healthcare. Here are several new developments poised to disrupt in 2018 and beyond.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/4-disruptive-trends-shaping-the-healthcare-sector/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>What to Look for in HIPAA Compliant Text Services</em>
                                            <p>What to Look for in HIPAA Compliant Texting Many patients prefer to text, but what about compliance issues? </p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/what-to-look-for-in-hipaa-compliant-text-services/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>What’s the Latest on Apple’s Healthkit Devices?</em>
                                            <p>What’s the Latest on Apple Healthkit Devices? Apple HealthKit devices are changing the way people manage and participate in their own well-being.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/whats-the-latest-on-apples-healthkit-devices/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>How Health Tech Is Disrupting the Industry</em>
                                            <p>How Health Tech Is Disrupting the Industry The tech industry is continuing to revolutionize the way people experience healthcare.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/how-health-tech-is-disrupting-the-industry/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='health-wrap'>
                                        <div className='health-blog-list'>
                                            <strong>AI Medical</strong>
                                            <em>Top 5 Healthcare Technology Trends to Watch in 2018</em>
                                            <p>2018 is poised to be a big YEAR for health tech. But which trend is about to take over? Here are five big healthcare technology trends to watch in the new year.</p>
                                            <div className='readmore'>
                                                <a href='https://blog.ionixxtech.com/top-5-healthcare-technology-trends-to-watch-in-2018/'>Read more</a>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                    
                    
                    

                    <div className='section-8'>
                        <div className='custom-container'>
                            <div className="main-head-div">
                                <h4 className="main-head-1">
                                    <span className="primary-span new-heading">Webinars</span>
                                </h4>
                            </div>
                            <div className='webinar-showcase'>
                                <Slider {...webinarSettings}>
                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>Technology's Impact on Healthcare Ep 1: EHRs</strong>
                                            <p>The digital information age is clearly making the case for the penetration of technology into every arm of healthcare.
                                                Against this background,
                                                1. How do EHRs come into play?
                                                <a href='https://www.youtube.com/watch?v=1nF0K3lOjv4' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=1nF0K3lOjv4' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinar_Ep-1.jpg' alt="Webinar Episode 1" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=1nF0K3lOjv4' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>Technology’s Impact on Healthcare Ep 2: FHIR/Interoperability</strong>
                                            <p>Why is interoperability in healthcare a huge deal?

                                                While the nature of healthcare data is a growing paradox, it is important to be be able to improve accessibility of data to enhance patient outcomes.
                                                <a href='https://www.youtube.com/watch?v=5jJAqOdKD_4' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=5jJAqOdKD_4' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinar_Ep-2.jpg' alt="Webinar Episode 2" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=5jJAqOdKD_4' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>Technology’s Impact on Healthcare Ep 3: Remote Patient Monitoring</strong>
                                            <p>Remote Patient Monitoring (RPM) has been steadily gaining a lot of spotlight in the post-pandemic health landscape. Much of this can be attributed to the CPT codes added by CMS and the explosion of telehealth consultations that was in part sparked by COVID-19.
                                                <a href='https://www.youtube.com/watch?v=lTYhSdPSXCU' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=lTYhSdPSXCU' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinar_Ep-3.jpg' alt="Webinar Episode 3" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=lTYhSdPSXCU' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>Technology’s Impact on Healthcare Ep 4: Medical Device Software</strong>
                                            <p>As we leverage the power of computing devices and connectivity, there’s a convergence of people, information, and technology in healthcare.

                                                Software as a Medical Device (SaMD) is increasingly becoming popular
                                                <a href='https://www.youtube.com/watch?v=i6pgH8Cf238' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=i6pgH8Cf238' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinar_Ep-4.jpg' alt="Webinar Episode 4" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=i6pgH8Cf238' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>Technology’s Impact on Healthcare Ep 5: Healthcare Security</strong>
                                            <p>Headline-grabbing cyber attacks have been dominating the news across almost all industries. The healthcare sector is no exception.

                                                Prone to vulnerabilities like any other, the health tech ecosystem is the target of hackers as weak hospital IT infrastructure could potentially expose critical patient data and sensitive payment information.
                                                <a href='https://www.youtube.com/watch?v=N1ONUTWnqyU' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=N1ONUTWnqyU' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinar_Ep-5.jpg' alt="Webinar Episode 5" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=N1ONUTWnqyU' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>Technology’s Impact on Healthcare Ep 6: Healthcare AI</strong>
                                            <p>We keep seeing headlines on how AI, Robotics, and Machine Learning are all poised to take several industries by storm and transform them at large. Is healthcare also one among them?
                                                <a href='https://www.youtube.com/watch?v=6UfmzV9F8lc' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=6UfmzV9F8lc' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinar_Ep-6.jpg' alt="Webinar Episode 6" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=6UfmzV9F8lc' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>The Evolving Role of AI in Diagnosing and Treating Patients</strong>
                                            <p>Ionixx presents an insightful webinar exploring The Evolving Role of AI in Diagnosing and Treating Patients with Dr. Maanas Samant, CMIO at Ionixx Technologies
                                                <a href='https://www.youtube.com/watch?v=Ppc0rBR78BY' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=Ppc0rBR78BY' target='_blank'>
                                                    <img src='/assets/img/health-img/HCWebinaronRoleofAI.jpg' alt="Webinar Role of AI" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=Ppc0rBR78BY' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='webinar-wrap'>
                                        <div className='webinar-list'>
                                            <strong>The Evolution, Impact, and Opportunities of ePrescribing</strong>
                                            <p>Watch our webinar with Dr. Maanas Samant as he traces the evolution of eRx and takes us through how it has expanded to a more comprehensive system today. Not to forget -- Benefits of eRx for your healthcare practice, roadblocks to implementation, and future outlook are also discussed in depth.
                                                <a href='https://www.youtube.com/watch?v=4bFj3PBJDnQ' target='_blank'>Readmore</a>
                                            </p>
                                            <div className='webinar-img'>
                                                <a href='https://www.youtube.com/watch?v=4bFj3PBJDnQ' target='_blank'>
                                                    <img src='/assets/img/health-img/e-prescribe-banner.jpg' alt="Webinar Role of AI" />
                                                </a>
                                            </div>
                                            <div className='webinar-foot'>
                                                <a href='https://www.youtube.com/watch?v=4bFj3PBJDnQ' target='_blank'>View Webinar</a>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='webinar-list'>
                         <strong>Web3 And The Future Of Healthcare</strong>
                         <p>What can Web3 bring to the table for healthcare transformation? Is it a winning combination?</p>
                         <div className='webinar-img'>
                         <img src='/assets/img/health-img/web3-webinar.jpg'/>
                         </div>
                         <div className='webinar-foot'>
                            <a href='https://www.bigmarker.com/ionixx-technologies1/Web3-And-The-Future-Of-Healthcare-1569ccb48d1e84f93aaf8161' target='_blank'>View Webinar</a>
                         </div>
                    </div> */}
                                </Slider>
                            </div>
                        </div>
                    </div >

                    <div className='section-9'>
                        <div className='custom-container'>
                            <div className="main-head-div">
                                <h4 className="main-head-1">
                                    <span className="primary-span">Speak to our expert</span>
                                </h4>
                            </div>
                            <div className='expert-speak'>
                                <div className='expert-left'>
                                    <div className='expert-info'>
                                        <div className='expert-img'>
                                            <img src='/assets/img/health-img/maanas.png' />
                                        </div>
                                        <div className='expert-detail'>
                                            <strong>Dr. Maanas Samant</strong>
                                            <em>CMIO, Ionixx Technologies</em>
                                            <span>maanas-office@ionixxtech.net</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='expert-right'>
                                    <p>Dr. Maanas Samant is a Physician, Clinical Product Expert, and HealthTech Advisor with over a decade of expertise in hospital, policy, payments, and health technology. He also offers valuable insights to Fortune 500 companies and Institutional Investors as a consultant. Additionally, he serves as the CMIO, leading the Healthcare Vertical at Ionixx Technologies.</p>
                                    <div className='book-consult'>
                                        <a href='https://calendly.com/maanas-office/30-minute-meet?month=2023-06' target='_blank'>Book a consultation!</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <ContactUS show={this.state.showContactUS} handleClose={() => this.setState({ showContactUS: false })} /> */}

<div className="section-3 testimonial-scroll-margin">
                        <TestimonialsNew />
                    </div>
    <div className="section-2 beige-bg company-info development-solution faq-listwrp health-faqs">
            <div className="custom-container">
              <div className="custom-section">
                <div className="main-head-div heading_lines">
                  <h1 className="main-head-1 faq">
                    <span className="primary-span">

                      Frequently Asked Questions
                    </span>
                  </h1>
                </div>
                <div className="row work-with-row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 work-with-col">
                    <div className={`faq parent ${this.state.showMore && 'active'}`}>
                    <Accordion className="faq-list">
                        <AccordionSummary
                          expandIcon={<ExIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="summary"
                        >
                          <h2 className="summary-content">
                            <span className="query-content"> What is your process of building custom healthcare solutions? 
</span></h2>
                        </AccordionSummary>
                        <AccordionDetails className="faq-details">
                          <Typography>
                            <span className="padding-left">
                              We follow a comprehensive three-step process for building custom healthcare solutions that involve the following phases in healthcare software development:
                           </span>
                            
                            <span className="padding-left"></span>
                            <div className="inline-accordion-details">
                             <p>Discovery</p>
                             <p>Agile Development and Testing</p>
                             <p>Launch and Support </p>
                            </div>
                          
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion className="faq-list">
                        <AccordionSummary
                          expandIcon={<ExIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="summary"
                        >
                          <h2 className="summary-content">
                            <span className="query-content">
                            What healthcare technology services does Ionixx offer?</span></h2>
                        </AccordionSummary>
                        <AccordionDetails className="faq-details">
                          <Typography>
                            <span className="padding-left">
                              As one of the leading healthcare software companies, we provide the following healthcare services:
                           </span>
                            
                            <span className="padding-left"></span>
                            <div className="inline-accordion-details">
                             <p>AI-Powered Healthcare</p>
                             <p>Health 4.0</p>
                             <p>HealthTech Air</p>
                             <p>Telemedicine Application Development</p>
                             <p>ePrescribing </p>
                            </div>
                          
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      
                      <Accordion className="faq-list">
                        <AccordionSummary
                          expandIcon={<ExIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="summary"
                        >
                          <h2 className="summary-content">
                            <span className="query-content">Are your digital healthcare solutions Health Insurance Portability and Accountability Act (HIPAA) compliant?
 </span></h2>
                        </AccordionSummary>
                        <AccordionDetails className="faq-details">
                          <Typography>
                            Yes, we follow the best practices to ensure high security and quality assurance throughout the healthcare software development lifecycle to stay HIPAA compliant.
                            
                            
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion className="faq-list">
                        <AccordionSummary
                          expandIcon={<ExIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="summary"
                        >
                          <h2 className="summary-content">
                            <span className="query-content"> What tech stack do you use for healthcare software development?
</span></h2>
                        </AccordionSummary>
                        <AccordionDetails className="faq-details">
                          <Typography>
                            <span className="padding-left">
                              We’re a leading healthcare software development company specializing in a diverse range of cloud platforms, microservices, UI/UX tools, web3 frameworks, mobile and web development stacks, databases, testing suites, and programming languages. Our expert teams leverage a mix of these technologies to build custom healthcare solutions that are tailored to the needs and requirements of our customers. 
                            </span>
                           
                          </Typography>

                        </AccordionDetails>
                      </Accordion>
                      <div className="child">
                        <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                               Do you provide mobile healthcare app development services?
</span></h2>
                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left">
                            Yes, we’re a healthcare app development company specializing in building native Android and iOS apps and cross-platform applications. Our experts can recommend the best way to adopt the particular application based on your requirements and end goal. 

                              </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                              What are AI-powered healthcare solutions?


                              </span></h2>

                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left">
                            AI-powered healthcare solutions harness artificial intelligence to deliver enhanced patient outcomes and care. For instance, AI is used in various healthcare services, such as medic predictive analytics for disease outbreaks, drug discovery, and diagnostic imaging.</Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                              What is Health Tech 4.0?
                              </span></h2>
                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left" >
                            <span className="padding-left">
                             Health Tech 4.0, often referred to as Healthcare 4.0, is the convergence of advanced medical technology like artificial intelligence, IoT, and data analytics in healthcare services to create a highly interconnected, data-driven, and patient-centric healthcare ecosystem. It aims to improve patient care, enhance healthcare delivery, and optimize processes through digital innovation and connectivity.</span>
                           
                            </Typography>
                          </AccordionDetails>
                        </Accordion>

                        
                       <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                              What are the trends driving the demand for custom healthcare software development?
                              </span></h2>
                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left" >
                            <span className="padding-left">
                            The growing demand for custom medical technology solutions within the healthcare industry is being fueled by evolving trends such as the expansion of telemedicine, the need for patient-centric care, the rise of data analytics and AI, and the importance of regulatory compliance. Custom software is essential for healthcare service providers to adapt, innovate, and securely integrate these technologies to ultimately improve patient care and operational efficiency in the healthcare companies.</span>
                           
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                              What role do EHR and EMR systems play in custom software development, and how do custom healthcare software development services enhance them?
                              </span></h2>
                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left" >
                            <span className="padding-left">
                            EHR (Electronic Health Record) and EMR (Electronic Medical Record) systems serve as critical components in custom software development for healthcare. These systems provide the foundation for managing patient data and healthcare workflows. Custom healthcare software development services enhance EHR and EMR systems by tailoring them to the unique needs of healthcare organizations.
                             This customization includes seamless integration with other healthcare applications, the addition of specialized features, improved user experience, robust data security measures, and compliance with regulatory standards like HIPAA. Custom software development services transform EHR and EMR systems into powerful tools that optimize patient care and streamline healthcare operations.</span>
                           
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                              What do I need before engaging with healthcare software companies to ensure the best healthcare software development services?
                              </span></h2>
                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left" >
                            <span className="padding-left">
                            Prior to our initial meeting, take the time to engage with your team and create an overview of the digital healthcare solutions you need, business challenges you want to overcome, key features to develop, long and short-term goals, and UI/UX design preferences or inspirations. It will enable us to scope your project requirements and ensure a productive first meeting for custom healthcare software development.</span>
                           
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion className="faq-list">
                          <AccordionSummary
                            expandIcon={<ExIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="summary"
                          >
                            <h2 className="summary-content">
                              <span className="query-content">
                              What is the typical process after hiring a healthcare software development company?
                              </span></h2>
                          </AccordionSummary>
                          <AccordionDetails className="faq-details">
                            <Typography className="padding-left" >
                            <span className="padding-left">
                            After a kick-off meeting, our collaboration unfolds through requirements gathering, design, development, testing, and deployment. We’re  a prominent healthcare app development company that follows the Agile software development methodology throughout the project to ensure flexibility, adaptability, transparency, and continuous collaboration.</span>
                           
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                    </div>

                    <div className="btn-wrp">
                      <button className="btn" onClick={() => { this.setState({ showMore: !this.state.showMore }) }}>{this.state.showMore ? 'View Less' : 'View More'} </button>
                    </div>



                  </div>

                </div>
              </div>
            </div>
          </div>

                    <Modal size='lg' show={this.state.show} onHide={() => this.handleClose()} centered>
                        <Modal.Header closeButton>
                        <Modal.Title className='health-care-heading'>Neuron</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ul className='health-care-list'>
                                <li><strong>Dynamic Data Integration:</strong> Neuron's platform seamlessly integrates with popular cloud environments and on-prem systems, enabling real-time population health insights without data migration hassles.</li>

<li><strong>Democratization of Data:</strong> Anchored by a design philosophy focused on data democratization, Neuron ensures fast, cost-effective analytics deployment, fostering a streamlined end-to-end experience.</li>

<li><strong>Flexible & Compliant:</strong> Crafted with regulatory standards in mind, Neuron scales to handle vast health populations while ensuring easy configuration, compliance, and adaptability across diverse care data ecosystems.</li>
                            </ul>
                        </Modal.Body>
                        {/* <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handleClose}>
                            Save Changes
                        </Button>
                        </Modal.Footer> */}
                    </Modal>                          
                </div >
            </>
        );
    }

}


const mapStateToProps = (state, ownProps) => {
    return state.commonReducer;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return bindActionCreators(contactAction, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Healthcare);
function ExIcon() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5227 3.04159L13.1523 13.412C12.5159 14.0484 11.4841 14.0484 10.8477 13.412L0.477287 3.04159C-0.159096 2.40521 -0.159096 1.37343 0.477287 0.737051C1.11367 0.100669 2.14545 0.100669 2.78183 0.737051L12 9.95522L21.2182 0.737052C21.8546 0.10067 22.8863 0.10067 23.5227 0.737052C24.1591 1.37343 24.1591 2.40521 23.5227 3.04159Z" fill="#42C2A2" />
      </svg>
    )
  }
